import React from "react";

import Styles from "./CorporateInfoModal.styles";
import { CorporateInfoModalProps as Props } from "./CorporateInfoModal.types";
import Button from "components/global/Button/Button";
import useI18n from "hooks/useI18n";

import CloseSVG from "../../../../public/assets/images/close.svg";
import TicketSVG from "../../../../public/assets/images/ticket-yellow.svg";

const CorporateInfoModal: React.FC<Props> = props => {
  const { onClose, ...rest } = props;
  const t = useI18n();

  const steps = [
    t.wallet.valid,
    t.wallet.noApplicable,
    t.wallet.noAccumulate,
    t.wallet.verify
  ];

  return (
    <Styles
      className="CorporateInfoModal"
      onClose={onClose}
      {...rest}
      color="transparent"
      closeIcon={<CloseSVG />}
    >
      <div className="CorporateInfoModal__content">
        <TicketSVG />
        <h3 className="CorporateInfoModal__title">{t.wallet.stepsTitle}</h3>

        <ul className="CorporateInfoModal__step-wrapper">
          {steps.map((step, index) => (
            <li key={index}>{step}</li>
          ))}
        </ul>

        <Button className="CorporateInfoModal__btn" onClick={onClose}>
          {t.common.understood}
        </Button>
      </div>
    </Styles>
  );
};

export default CorporateInfoModal;
